module.exports = __webpack_public_path__ + "static/image/service/pc/ceo.jpg?372ca987";